module.exports={
	"Form": "FundingCategoryViewManifest",
	"Scope": "FundingCategory-View",
	"Descriptors":
	{
		"FundingCategoryDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingCategory-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "FundingCategory-View-Identity",
				"Group": "FundingCategory-View-Identity"
			}
		},
		"FundingCategoryDetails.Code":
		{
			"Name": "Code",
			"Hash": "FundingCategory-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "FundingCategory-View-Identity",
				"Group": "FundingCategory-View-Identity"
			}
		},
		"FundingCategoryDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingCategory-View-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "FundingCategory-View-Details",
				"Group": "FundingCategory-View-Details"
			}
		},
		"FundingCategoryDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingCategory-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "FundingCategory-View-Details",
				"Group": "FundingCategory-View-Details"
			}
		},
		"FundingCategoryDetails.IDFundingCategory":
		{
			"Name": "IDFunding Category",
			"Hash": "FundingCategory-View-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.GUIDFundingCategory":
		{
			"Name": "GUIDFunding Category",
			"Hash": "FundingCategory-View-GUIDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "FundingCategory-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "FundingCategory-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "FundingCategory-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "FundingCategory-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingCategory-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingCategory-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingCategory-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingCategory-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "FundingCategory-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "FundingCategory-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
